import React from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';

import countyList from '../../data/tx_county_list.json';
import schoolDistrictList from '../../data/tx_school_district_name_list.json';

export default function YearCountyDistrictSrchForm(props) {
  return (
    <Card mx='auto'>
      <CardContent display='flex' m={1} p={1}>
        <Typography variant='h5' component='h2'>
          District Search
        </Typography>
        <Grid container alignItems='center' spacing={2} justify='center'>
          <Grid item xs={12} md={12}>
            <Autocomplete
              multiple
              id='year'
              options={schoolYears}
              getOptionLabel={(option) => option.year}
              onChange={(event, newValue) => {
                props.onYearChange(newValue);
              }}
              /* defaultValue={[schoolYears[9]]} */
              renderInput={(params) => <TextField {...params} variant='standard' label='School Year' placeholder='2020-2021' />}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Autocomplete
              multiple
              id='county'
              options={countyList}
              getOptionLabel={(option) => option.county}
              onChange={(event, newValue) => {
                props.onCountyChange(newValue);
              }}
              /*  defaultValue={[props.data[13]]} */
              renderInput={(params) => <TextField {...params} variant='standard' label='County' placeholder='County Name' />}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Autocomplete
              multiple
              id='district_name'
              options={schoolDistrictList}
              getOptionLabel={(option) => option.district_name}
              onChange={(event, newValue) => {
                props.onDistrictChange(newValue);
              }}
              /*  defaultValue={[props.data[13]]} */
              renderInput={(params) => <TextField {...params} variant='standard' label='District' placeholder='District Name' />}
            />
          </Grid>
          {/*    <Grid item xs={12} md={3}>
            <TextField
              id='zip'
              label='Zip Code'
              type='text'
              value={props.data.zip}
              onChange={props.onValidChange}
              inputProps={{ readOnly: props.readOnly }}
              helperText={props.errors['zip'] || 'Zipcode'}
              fullWidth={true}
              error={props.errors['zip']}
              required
            />
          </Grid> */}
          <Grid container item xs={12} spacing={5} direction='row' justify='center' alignItems='center'>
            <Grid item xs={3}>
              <Button
                variant='contained'
                size='large'
                color='primary'
                startIcon={<SearchIcon />}
                onClick={props.onSearch}
                /* disabled={props.data.streetNum.length > 0 && props.data.streetName.length > 1 && props.data.zip.length > 4 && !Object.keys(props.errors).length > 0 ? false : true} */
              >
                {'Search'}
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button variant='contained' size='large' startIcon={<ReplayIcon />} onClick={props.onReset}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

const schoolYears = [
  { year: '2011-2012' },
  { year: '2012-2013' },
  { year: '2013-2014' },
  { year: '2014-2015' },
  { year: '2015-2016' },
  { year: '2016-2017' },
  { year: '2017-2018' },
  { year: '2018-2019' },
  { year: '2019-2020' },
  { year: '2020-2021' },
];
